import 'reflect-metadata';
import { METADATA_TOKEN } from '../Constants';
export function injectable(options) {
    return (target) => {
        const dependencyOptions = Object.assign(Object.assign({ type: 'multiton' }, (Reflect.getMetadata(METADATA_TOKEN, target) || {})), options);
        Reflect.defineMetadata(METADATA_TOKEN, dependencyOptions, target);
        return target;
    };
}
